/** @format */

import clsx from "clsx";
import React, { useCallback } from "react";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import { InputTextarea } from "primereact/inputtextarea";
import useStopSurvey from "./hooks/useStopSurvey";
import useGetSurveyById from "./hooks/useGetSurveyById";
import { useQueryClient } from "@tanstack/react-query";
import "primeflex/primeflex.css";

import ThreeDotsLoader from "../common/ThreeDotsLoader";

import { SURVEY } from "./constants/constants";

import "../../style/news.css";

const View = ({ status, isActive, isInProgress, isInactive, resetView, id, toastRef }) => {
  const stopMutation = useStopSurvey(id);
  const queryClient = useQueryClient();
  const { data, isLoading } = useGetSurveyById(id);
  const stopSurvey = useCallback(() => {
    stopMutation.mutate(id, {
      onSuccess: () => {
        toastRef.current.show({
          severity: "success",
          summary: "Success",
          detail: "Survey stopped successfully",
          life: 1000,
        });
        queryClient.invalidateQueries({
          queryKey: ["getAllSurvey"],
        });
      },
      onError: () => {
        toastRef.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error stopping Survey",
          life: 1000,
        });
      },
    });
  }, [stopMutation, queryClient, id, toastRef]);
  let description = data?.description;
  let questionRequestDTOS = data?.questionRequestDTOS ?? [];
  return (
    <>
      {isLoading || stopMutation.isLoading ? (
        <div className='wtg__loader'>
          <ThreeDotsLoader />
        </div>
      ) : null}
      <View.Header
        title={data?.title}
        need={data?.need}
        status={status}
        isActive={isActive}
        isInProgress={isInProgress}
        isInactive={isInactive}
      />
      <p>
        <b>Survey Description</b>
      </p>
      <p style={{ border: "1px solid #F5F5F5", borderRadius: "10px" }} className='p-2 mt-2'>
        {description}
      </p>
      <ol className='survey__preview__question__list mt-6'>
        {questionRequestDTOS.map((question, index) => {
          return (
            <li className='mt-4' key={question.questionId}>
              <b>{question.name}</b>
              <ul className='mt-3'>
                {question.type === SURVEY.QUESTION__TYPES.MULTIPLE__CHOICE ? (
                  question.optionRequestDTOS.map((optionDTO) => {
                    return (
                      <li className='my-2 mr-3' key={optionDTO.optionId}>
                        <RadioButton value='' name='' checked={false} disabled className='mx-3' />
                        {optionDTO.option}
                      </li>
                    );
                  })
                ) : (
                  <li className='my-2 mr-3'>
                    <InputTextarea id='survey__detail' readOnly rows={5} />
                  </li>
                )}
              </ul>
            </li>
          );
        })}
      </ol>
      <View.Footer isActive={isActive} stopSurvey={stopSurvey} resetView={resetView} />
    </>
  );
};

View.Footer = ({ isActive, stopSurvey, resetView }) => (
  <div className='p-dialog-footer'>
    {isActive ? (
      <Button label='Stop Survey' onClick={stopSurvey} className='p-button p-button-sm btn3 stop__survey' />
    ) : null}
    <Button label='Close' onClick={resetView} className='p-button p-button-sm btn3' />
  </div>
);

View.Header = ({ title, need, status, isActive, isInProgress, isInactive }) => (
  <div id='dialog__survey__details_header'>
    <p>
      <b>{title}</b>
    </p>
    <p>{need}</p>
    <p>
      <b>Status: </b>
      <span
        className={clsx({
          survey__active: isActive,
          survey__inprogress: isInProgress,
          survey__inactive: isInactive,
        })}
      >
        {status}
      </span>
    </p>
  </div>
);

export default View;
